import { Salary } from '@/types';

export const formatSalaryNumber = (currency: string | number) => String(currency).replace(/\B(?=(\d{3})+(?!\d))/g, ' ');

export const formatSalary = ({ from, to, currency }: Salary): string => {
  return formatSalaryNumber(`${from} - ${to} ${currency.toUpperCase()}`);
};
